module.exports = __webpack_public_path__ + "static/himna-70df0dc3a36e7a218d8576614dd08eb1.mp3";